import makeValidationSchema from './StatusNotificationMakeValidationSchema'
import { components, useTranslation } from 'cng-web-lib'
import React, { useCallback, useContext } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import { StatusNotificationContext } from './StatusNotificationContext'
import Switch from 'src/components/Switch'
import Namespace from 'src/constants/locale/Namespace'
import UserProfileKeys from 'src/constants/locale/key/UserProfile'

const {
  form: {
    field: { CngTextField, CngSelectField }
  }
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  notifyType: 'ALL',
  email: '',
  faxNum: '',
  destination: 'CBP',
  receiveRNSWithoutSubmission: false,
  assignedTripDriver: false
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ index }) {
  const { getOptions } = useContext(StatusNotificationContext)
  const { setValue, watch } = useFormContext()
  const { translate } = useTranslation(Namespace.USER_PROFILE)

  const getFieldName = useCallback((field) => {
    return typeof index === 'number' ? `notis.${index}.${field}` : field
  }, [])

  const destination = watch(getFieldName('destination'))
  const assignedTripDriver = watch(getFieldName('assignedTripDriver'))

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <CngSelectField
          label='Destination'
          name={getFieldName('destination')}
          isRequired
          size='small'
          onChange={() => {
            setValue(getFieldName('notifyType'), 'ALL')
            setValue(getFieldName('faxNum'), null)
          }}
          items={[
            { text: 'CBP', value: 'CBP' },
            { text: 'CBSA', value: 'CBSA' },
            { text: 'NBCI', value: 'NBCI' },
            { text: 'ACEOCN', value: 'ACEOCN' },
            { text: 'ACEISF', value: 'ACEISF' },
            { text: 'FDA', value: 'FDA' }
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <CngSelectField
          disabled={!destination}
          label='Status Notification Type'
          name={getFieldName('notifyType')}
          isRequired
          size='small'
          items={getOptions(destination)}
        />
      </Grid>
      <Grid item xs={12}>
        <CngTextField
          helperText=""
          name={getFieldName('email')}
          label='Email Address'
          size='small'
          isRequired={!assignedTripDriver}
          disabled={assignedTripDriver}
        />
      </Grid>
      {destination != 'NBCI' &&
        <Grid item xs={12}>
          <CngTextField
            name={getFieldName('faxNum')}
            label='Fax Number'
            size='small'
        />
        </Grid>
      }
      {destination != 'NBCI' &&
        <Grid item xs={12}>
          <CngTextField
            name={getFieldName('mobileNum')}
            label='Mobile Number'
            size='small'
          />
        </Grid>
      }
      {destination === 'CBSA' &&
        <Grid item xs={12}>
          <Switch
            fullWidth
            name="receiveRNSWithoutSubmission"
            label="Receive RNS without Submission"
            onChange={(event) => {
              setValue('receiveRNSWithoutSubmission', event.target.checked, { shouldDirty: true })
            }}
          />
        </Grid>
      }
      {destination != 'FDA' &&
        <Grid item xs={12}>
          <Switch
            fullWidth
            name={getFieldName('assignedTripDriver')}
            label="Assigned Trip Driver"
            onChange={(event) => {
              const checked = event.target.checked
              setValue(getFieldName('assignedTripDriver'), checked, { shouldDirty: true })
              if (checked) {
                setValue(getFieldName('email'), '', { shouldDirty: true })
              }
            }}
          />
          {assignedTripDriver && destination === 'CBP' &&
            <Typography variant='caption' color='textSecondary' style={{ marginTop: 4, display: 'block' }}>
              {translate(Namespace.USER_PROFILE, UserProfileKeys.StatusNotification.DRIVER_NOTIFICATION_DEFAULT_CBP_MESSAGE)}
            </Typography>
          }
          {assignedTripDriver && destination === 'CBSA' &&
            <Typography variant='caption' color='textSecondary' style={{ marginTop: 4, display: 'block' }}>
              {translate(Namespace.USER_PROFILE, UserProfileKeys.StatusNotification.DRIVER_NOTIFICATION_DEFAULT_CBSA_MESSAGE)}
            </Typography>
          }
        </Grid>
      }
    </Grid>
  )
}

const StatusNotificationFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default StatusNotificationFormProperties
